import registerBreadcrumbs from './breadcrumbs';
import registerDisableSidebarAffix from './disable-sidebar-affix';
import registerFooterNormalizer from './footer-normalizer';
import registerHeaderLogoLink from './header-logo-link';
import registerHeaderSearchInput from './header-search-input';
import registerOidcLogin from './oidc-login';
import registerTerms from './terms';

/**
 * Register new forum-side behaviour here.
 * Each module should export a default function that wires Flarum extend()/override() calls.
 */
const featureModules = [registerBreadcrumbs, registerDisableSidebarAffix, registerFooterNormalizer, registerHeaderLogoLink, registerHeaderSearchInput, registerOidcLogin, registerTerms];
export default featureModules;
flarum.reg.add('dia-theme', 'forum/features', featureModules);